var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('SearchForm'),(_vm.displaySearchResults)?_c('v-row',[_c('v-col',{staticClass:"text-center pt-0",attrs:{"cols":"12"}},[(!_vm.noResults)?_c('SearchResultsWrapper'):_c('div',[_vm._v("No Results")])],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }